import React from 'react';
import styled from 'styled-components';
import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux'
import H1 from "../../Components/H1";
import {ToolbarWithLogo} from '../../Components/Toolbar';
import ContainerPage from "../ContainerPage";
import {getSpecificOptions, resetWizard} from '../Welcome/Actions';
import {BottomWrapper, SelectViewWrapper, TopWrapper} from '../../Components/Layout';
import PoweredBy from "../../Components/PoweredBy";
import Select from "../../Components/Select";
import Sizes from "../../Assets/Sizes";
import FullPageLoader from "../../Components/FullPageLoader";
import {NavigationBottomButton} from "../../Components/NavigationButton";
import {humanizeDayOfWeek, serverDayDate, serverShortTime} from "../../Common/Helpers";
import ProgressTracker from "../../Components/ProgressTracker";
import H2 from "../../Components/H2";
import {CSSTransition} from "react-transition-group";
import Toast from "../../Components/Toast";
import Link from "../../Components/Link";
import AppointmentApprovalDialog from "../../Components/AppointmentApprovalDialog";
import {getSafely, valueOrDefault} from "@tomeravni/easybizy-js-common/common";
import {PROGRESS_KEY} from "../../Common/constants";


const MyTopWrapper = styled(TopWrapper)`
    .appear-enter {
        opacity: 0;
        transform: translateX(100%);
    }

    .appear-enter-active {
        opacity: 1;
        transform: translateX(0);
        transition: all 500ms ease-in;
    }
`;

const HH1 = styled(H1)`
    z-index: 1;
    text-align: center;
    width: 100%;
    padding-top: 0;
`;

const TimeOption = styled.div`
    display: flex;
    align-items: center;
`;
const Time = styled.div`
    font-size: 0.85em;
    // margin-left: 0.5em;
    margin-right: 0.5em;
`;

const NotFoundWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: ${Sizes.defaultPadding};
    padding-right: ${Sizes.defaultPadding};
    height: 100%;
    align-items: center;
    justify-content: center;
`;

const HH2 = styled(H2)`
    margin-bottom: ${Sizes.defaultPadding};
`;

const LoadMoreButton = styled(NavigationBottomButton)`
    margin-top: ${Sizes.defaultPadding};
    margin-bottom: ${Sizes.defaultPadding};
}`;

const MAX_RESULTS = 45;

class ResultsPage extends ContainerPage {
    state = {};

    constructor(props) {
        super(props);
    }

    confirmAndCreateMeeting(option) {
        const forcedRemarks = this.props.services.find(s => s.ForceRemarks) || {};
        this.confirmDialog.confirm(option, this.props.config.EnableRemarks,
            forcedRemarks.ForceRemarks, forcedRemarks.RemarksPlaceHolder).then((result) => this.done(result))
            .catch((err) => {
                let errorMessage = 'Unknown Error';
                if (err.message) {
                    try {
                        errorMessage = this.props.intl.formatMessage({id: err.message});
                    } catch (e) {
                        // Ignore
                    }
                }

                this.showToastMessage(errorMessage);
            });
    }


    componentDidMount() {
        super.componentDidMount();
        if (this.props.scheduledMeeting) {
            this.props.resetWizard();
            this.startOver();
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        super.componentWillUpdate(nextProps, nextState, nextContext);
        if ((nextProps.services && nextProps.dayPart && nextProps.date) &&
            (!nextProps.loadingSpecificOptions && !nextProps.options && !this.specificOptionsError)) {
            this.loadOptions(nextProps);
            this.pageLoader.load();
        } else if (nextProps.options && !nextProps.loadingSpecificOptions) {
            this.pageLoader.done();
        } else if (nextProps.error) {
            this.pageLoader.error();
        }
    }

    loadOptions(props, date = null, loadMore = false) {
        let serviceIds = props.services.map(service => service.OnlineBookingServiceId).join(',');
        let employeeId = (props.config.AllowPickingEmployees && props.employee) ? props.employee.EmployeeId : null;

        this.props.getOptions(this.getCustomerToken(), serviceIds, employeeId,
            props.dayPart, date || props.date, loadMore, this.props.existingMode, props.gendersMap, props.quantityMap);
    }

    loadMore() {
        if (!this.props.options) {
            return;
        }


        this.loadOptions(this.props, this.props.options[this.props.options.length - 1].Start, true)
    }

    adaptOption(option) {
        const employeeName = this.props.config.AllowPickingEmployees ?
            <span>,&nbsp;{option.EmployeeName}</span> : undefined;

        return <TimeOption>{humanizeDayOfWeek(option.Start)},&nbsp;
            <Time>{serverDayDate(option.Start)}{employeeName}</Time></TimeOption>
    }

    adaptSublabel(option) {
        if (this.props.config?.HideServiceEndTime) {
            return <div>{serverShortTime(option.Start)}</div>
        }

        return <div>{serverShortTime(option.Start)} - {serverShortTime(option.End)}</div>
    }

    render() {
        const hasOptions = this.didMount && this.props.options && this.props.options.length > 0;
        const noOptionsFound = !this.props.loadingSpecificOptions && this.props.options && this.props.options.length === 0;
        let maxedOutResults = this.props.options && this.props.options.length >= MAX_RESULTS;
        const currentProgressIndex = valueOrDefault(this.props.progress, []).findIndex((p) => p.label === PROGRESS_KEY.SERVICE) || 0;
        const ltr = !this.props.intl.locale.includes('he');
        const toolbarLogo = getSafely(['theme', 'properties', 'avatarImage'], window) || (this.props.config && this.props.config.Logo) || '';


        return (
            <div className="transition-item detail-page detail-page__results">
                <SelectViewWrapper padding={true} bottomPadding={false} loading={this.props.loading} ltr={ltr}>
                    <ToolbarWithLogo imageUri={toolbarLogo} ltr={ltr} rootUri={this.getRoutePrefix()}>
                        <ProgressTracker progress={this.props.progress} current={currentProgressIndex} visible={true}/>
                    </ToolbarWithLogo>

                    <MyTopWrapper justify="start" align="start" padding={true} preventFlex={true}
                                  className="page__content">
                        {!this.specificOptionsError &&
                            <HH1><FormattedMessage id="schedule.chooseASchedule"/></HH1>}
                        {hasOptions &&
                            <Select
                                ltr={ltr}
                                preventPaddingBottom={true}
                                selected={this.props.dateOption}
                                keyProp="Start"
                                onClick={(option) => this.confirmAndCreateMeeting(option)}
                                autoScrollNewPage={true}
                                darkenOptionsEvery={15}
                                items={this.props.options}
                                subLabalProp={(option) => this.adaptSublabel(option)}
                                nameProp={(option) => this.adaptOption(option)}>
                                {/*THIS IS CHILDREN COMPOSITION OPTION.*/}
                                <LoadMoreButton
                                    disabled={this.props.loadingSpecificOptions || maxedOutResults}
                                    loading={this.props.loadingSpecificOptions.toString()}
                                    onClick={() => this.loadMore()}
                                    custom-theme="shallow-button"
                                    icon="favorite"><FormattedMessage
                                    id={!maxedOutResults ? "schedule.loadMoreOptions" : "schedule.cannotloadMoreOptions"}/>
                                </LoadMoreButton>

                            </Select>}
                        <CSSTransition
                            in={noOptionsFound}
                            unmountOnExit
                            timeout={1000}
                            classNames="appear">
                            <NotFoundWrapper>
                                <HH2><FormattedMessage id="schedule.notAppointmentsFound"/></HH2>
                                <NavigationBottomButton
                                    onClick={() => this.loadPreviousRoute()}
                                    custom-theme="shallow-button"
                                    icon="favorite"><FormattedMessage
                                    id="schedule.modifySearchRange"/></NavigationBottomButton>

                            </NotFoundWrapper>
                        </CSSTransition>

                        <CSSTransition
                            in={!!this.specificOptionsError}
                            unmountOnExit
                            timeout={1000}
                            classNames="appear">
                            <NotFoundWrapper>
                                <HH2>{this.specificOptionsError}</HH2>
                                <Link
                                    href={`tel:${this.props.config && this.props.config.BusinessPhoneNumber}`}><NavigationBottomButton
                                    custom-theme="shallow-button"
                                    icon="favorite"><FormattedMessage
                                    id="schedule.callUs"/></NavigationBottomButton></Link>

                            </NotFoundWrapper>
                        </CSSTransition>

                        <FullPageLoader ref={r => this.pageLoader = r}/>

                    </MyTopWrapper>
                    <BottomWrapper empty={true}>
                        <PoweredBy/>
                    </BottomWrapper>
                </SelectViewWrapper>
                <Toast ref={(toast) => this.toast = toast}/>
                <AppointmentApprovalDialog
                    innerRef={(confirmDialog) => this.confirmDialog = confirmDialog}/>
            </div>
        )
    }
}

/** Styled-Components **/

/** END OF Styled-Components **/

const mapStateToProps = state => {
    return {
        loading: state.schedule.fetchingConfig || state.schedule.fetchingServices,
        config: state.schedule.configWithServices,
        progress: state.schedule.progress,
        services: state.schedule.services,
        employee: state.schedule.employee,
        dayPart: state.schedule.stateParams ? state.schedule.stateParams.day_part : null,
        date: state.schedule.stateParams ? state.schedule.stateParams.date : null,
        loadingSpecificOptions: state.schedule.fetchingSpecificOptions,
        options: state.schedule.specificOptions,
        error: state.schedule.errorSpecificOptions,
        schedulingMeeting: state.schedule.schedulingMeetings,
        scheduledMeeting: state.schedule.scheduledMeeting,
        existingMode: state.schedule.existingMode,
        gendersMap: state.schedule.itemsGenderMap,
        quantityMap: state.schedule.itemsQuantityMap
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getOptions: (token, serviceIds, employeeId, dayPart, date, loadMore = false, existingMode, genderMap, quantityMap) =>
            dispatch(getSpecificOptions(token, serviceIds, employeeId, dayPart, date, loadMore, existingMode, genderMap, quantityMap)),
        resetWizard: () => dispatch(resetWizard())

    }
};


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ResultsPage));
